import React from "react";
import {
  FaSpaceShuttle,
  FaRocket,
  FaLink,
  FaUserFriends,
  FaMobileAlt,
  FaShieldAlt,
  FaCoins,
  FaChartLine,
  FaSyncAlt,
} from "react-icons/fa";

function StunningFeatures() {
  return (
    <>
      <div className="team-single-area default-padding">
        <div className="container">
          <div className="team-single-items">
            <div className="row">
              <div className="col-lg-5 left-info">
                <div className="thumb fade-up-anim">
                  <img
                    src="https://validthemes.net/site-template/robok/assets/img/team/5.jpg"
                    alt="Thumb"
                  />
                </div>
              </div>
              <div className="col-lg-7 right-info pl-30 pl-md-15 pl-xs-15">
                <div className="container">
                  <div className=" col-lg-12">
                    <div className="site-heading">
                      <h4 className="sub-title">Our Services</h4>
                      <h2 className="title split-text-right split-text-in-right split-lines">
                        Stunning features of our DeFi Wallet
                      </h2>
                    </div>
                  </div>
                </div>
                <div className="container">
                  <div className="services-style-four-items">
                    <div className="services-style-four-item">
                      <div className="icon">
                        <FaSpaceShuttle size={35} />
                      </div>
                      <h4>Multi-Blockchain Compatibility</h4>
                      <p>
                        Our DeFi wallets support multiple blockchain networks,
                        including Ethereum, Binance Smart Chain (BSC), Solana,
                        Polygon, and more. This allows users to access and
                        interact with various DeFi ecosystems without
                        limitations.
                      </p>
                    </div>

                    <div className="services-style-four-item">
                      <div className="icon">
                        <FaRocket size={35} />
                      </div>
                      <h4>Non-Custodial Wallets</h4>
                      <p>
                        Xeer Technology develops non-custodial wallets, ensuring
                        that users retain full control over their private keys
                        and funds. We prioritize security and ownership,
                        providing peace of mind while transacting on DeFi
                        platforms.
                      </p>
                    </div>

                    <div className="services-style-four-item">
                      <div className="icon">
                        <FaLink size={35} />
                      </div>
                      <h4>Seamless Integration with DeFi Protocols</h4>
                      <p>
                        Our DeFi wallets are built for seamless interaction with
                        decentralized finance protocols, enabling users to
                        easily perform activities like staking, yield farming,
                        lending, borrowing, and liquidity provision across DeFi
                        platforms.
                      </p>
                    </div>

                    <div className="services-style-four-item">
                      <div className="icon">
                        <FaUserFriends size={35} />
                      </div>
                      <h4>User-Friendly Interface</h4>
                      <p>
                        Designed with a focus on ease of use, our wallets offer
                        a simple and intuitive interface that ensures users can
                        navigate the world of decentralized finance
                        effortlessly, regardless of their experience level.
                      </p>
                    </div>

                    <div className="services-style-four-item">
                      <div className="icon">
                        <FaMobileAlt size={35} />
                      </div>
                      <h4>Integrated DApp Browser</h4>
                      <p>
                        Our wallets feature an integrated DApp (Decentralized
                        Application) browser, allowing users to explore and
                        connect with various DeFi applications directly from the
                        wallet. Whether you want to swap tokens, access
                        decentralized exchanges, or use yield farming platforms,
                        everything is available at your fingertips.
                      </p>
                    </div>

                    <div className="services-style-four-item">
                      <div className="icon">
                        <FaShieldAlt size={35} />
                      </div>
                      <h4>Enhanced Security Features</h4>
                      <p>
                        Security is paramount in the DeFi space. Our wallets
                        come equipped with multi-factor authentication (MFA),
                        biometric security, encryption, and secure private key
                        storage. We also support multi-signature authorization
                        for added protection.
                      </p>
                    </div>

                    <div className="services-style-four-item">
                      <div className="icon">
                        <FaCoins size={35} />
                      </div>
                      <h4>Support for DeFi Tokens & Assets</h4>
                      <p>
                        Our wallets support a wide variety of DeFi tokens,
                        including ERC-20, BEP-20, and others. Additionally,
                        users can manage NFTs (non-fungible tokens) and other
                        digital assets in the same wallet, providing a
                        comprehensive DeFi experience.
                      </p>
                    </div>

                    <div className="services-style-four-item">
                      <div className="icon">
                        <FaChartLine size={35} />
                      </div>
                      <h4>Real-Time Transaction Monitoring</h4>
                      <p>
                        Keep track of all your transactions with real-time
                        monitoring and detailed transaction history. This
                        feature helps users stay informed about their DeFi
                        activities and ensures transparency in every
                        interaction.
                      </p>
                    </div>

                    {/* <div className="services-style-four-item">
                      <div className="icon">
                        <FaSyncAlt size={35} />
                      </div>
                      <h4>Cross-Platform Syncing</h4>
                      <p>
                        Xeer Technology ensures that your DeFi wallet can be
                        accessed across multiple platforms, including mobile
                        (iOS and Android), desktop, and web applications. This
                        ensures convenience and continuity in managing your DeFi
                        assets on any device.
                      </p>
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default StunningFeatures;
